const PARAM_PATTERN = /:([A-Za-z0-9_]+)/g;

export function buildEndpoint(
  template: string,
  params: Record<string, string | number | null | undefined>
): string {
  return template.replace(PARAM_PATTERN, (_, key: string) => {
    const rawValue = params[key];
    if (rawValue === null || rawValue === undefined) {
      throw new Error(`Missing endpoint param: ${key}`);
    }

    const value = String(rawValue).trim();
    if (!value) {
      throw new Error(`Endpoint param "${key}" must not be empty`);
    }

    return encodeURIComponent(value);
  });
}
